// /**
//  * cart-tracking.js
//  * ─────────────────────────────────────────────────────────────────
//  * GA4 + Smartech tracking for add/remove cart events.
//  * Listens to: variant:added | cart:updated
//  *
//  * GA4 item objects are taken WHOLE from the product page's
//  *   <script id="product-collection-data" type="application/json">
//  * block. That block exposes an `items` array — one fully-formed
//  * GA4 item per variant (item_id, item_name, index, item_brand,
//  * item_category, item_category2, item_category3, item_variant,
//  * price, quantity). The JS no longer constructs any of this; it
//  * matches the right variant, decodes HTML entities, and attaches
//  * the runtime quantity.
//  *
//  * No dependency on cart-shared.js — uses its own /cart.js fetch
//  * so tracking is isolated and never contaminates the shared cache.
//  * ─────────────────────────────────────────────────────────────────
//  */
// (function () {
//   'use strict';

//   const BASE_URL = 'https://plumgoodness.com/products/';
//   const CURRENT_URL_TOKEN = '__CURRENT_URL__';

//   const GA4_EVENTS = {
//     add:    'add_to_cart',
//     remove: 'remove_from_cart',
//   };

//   const SMARTECH_EVENTS = {
//     add:    'add to cart custom',
//     remove: 'remove from cart custom',
//   };

//   // ─── State ──────────────────────────────────────────────────────────────

//   let previousCartMap        = null;
//   let lastCartFingerprint    = '';
//   let variantAddedInProgress = false;

//   // ─── Utility ──────────────────────────────────────────────────────────────

//   function getFormattedDateCart() {
//     const d = new Date();
//     return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
//   }

//   function getUserId() {
//     // Real Shopify customer id when logged in; '' for guests.
//     return window.ShopifyAnalytics?.meta?.page?.customerId ?? 'guest';
//   }

//   function normalizeProduct(data) {
//     return {
//       id:           parseInt(data.product_id ?? data.id, 10),
//       title:        data.product_title ?? data.title,
//       vendor:       data.vendor,
//       variant:      data.variant_title,
//       price:        parseFloat(data.price / 100),
//       image:        data.image,
//       handle:       data.handle,
//       product_type: data.product_type,
//     };
//   }

//   function buildCartMap(items) {
//     return items.reduce((map, item) => {
//       map[item.variant_id] = item;
//       return map;
//     }, {});
//   }

//   function cartFingerprint(items) {
//     return items.map((i) => `${i.variant_id}:${i.quantity}`).sort().join('|');
//   }

//   // Script-tag JSON is raw text, so entities like &amp; / &#39; arrive literal.
//   function decodeEntities(str) {
//     if (typeof str !== 'string' || !str.includes('&')) return str;
//     const el = document.createElement('textarea');
//     el.innerHTML = str;
//     return el.value;
//   }

//   function decodeItem(it) {
//     const out = {};
//     for (const key in it) {
//       out[key] = typeof it[key] === 'string' ? decodeEntities(it[key]) : it[key];
//     }
//     return out;
//   }



//   // ─── Product-block resolver ─────────────────────────────────────────────────
//   // Reads the `items` array out of the product page's
//   //   <script id="product-collection-data" type="application/json"> block.
//   // Cached per-handle so a busy cart never refetches the same product HTML
//   // (and never hammers Shopify into 429s).

//   const productItemsCache = new Map(); // handle -> [item, ...]

//   function getHandle(item) {
//     return item.handle ?? item.url?.split('/products/')[1]?.split(/[?#]/)[0] ?? '';
//   }

//   function parseProductItems(root) {    
//     if (!root) return null;
//     try {
//       const json  = JSON.parse(root.textContent.trim());
//       const items = Array.isArray(json.items) ? json.items : [];
// console.log('itemsitems', items);
//       return items.map(decodeItem);
//     } catch (_) {
//       return null;
//     }
//   }

//   async function getProductItems(rawItem) {
//     const handle = getHandle(rawItem);
//     if (!handle) return [];

//     if (productItemsCache.has(handle)) return productItemsCache.get(handle);

//     // Fast path: we're already on this product's page — block is in the live DOM.
//     const productId = rawItem.product_id ?? rawItem.id;
//     const inline    = parseProductItems(document.getElementById('product-collection-data'));
//     if (inline && inline.length && String(inline[0].item_id) === String(productId)) {
//       productItemsCache.set(handle, inline);
//       return inline;
//     }

//     // Otherwise fetch the product page HTML and read the block from it.
//     try {
//       const html  = await fetch(`/products/${handle}`).then((r) => r.text());
//       const doc   = new DOMParser().parseFromString(html, 'text/html');
//       const items = parseProductItems(doc.getElementById('product-collection-data')) ?? [];
// console.log('items', items);
//       productItemsCache.set(handle, items);
//       return items;
//     } catch (_) {
//       return [];
//     }
//   }

//   // Pick the variant-specific object from the block, matched on variant title.
//   function matchBlockItem(items, rawItem) {
//     if (!items.length) return null;
//     const variantTitle = rawItem.variant_title ?? rawItem.variant ?? '';
//     return (
//       items.find((it) => it.item_variant === variantTitle) ??
//       items[0]
//     );
//   }

//   async function resolveBlockItem(rawItem) {
//     const items = await getProductItems(rawItem);
//     return matchBlockItem(items, rawItem);
//   }

//   // ─── Payload builders ───────────────────────────────────────────────────────

//   // GA4 item = the whole object from the HTML block + runtime-only fields.
//   function buildGA4Item(blockItem, quantity) {
//     return {
//       ...blockItem,
//       item_list_name:
//         blockItem.item_list_name === CURRENT_URL_TOKEN
//           ? window.location.href
//           : blockItem.item_list_name,
//       quantity,
//     };
//   }

//   // Fallback only if the block/HTML is unreachable, so tracking never goes silent.
//   function buildFallbackItem(product, quantity) {
// console.log('product', product);
//     return {
//       item_id:        product.id,
//       item_name:      product.title,
//       item_brand:     product.vendor,
//       item_category:  '',
//       item_category2: '',
//       item_category3: '',
//       item_variant:   product.variant,
//       price:          product.price,
//       coupon:         '',
//       discount:       0,
//       item_list_name: window.location.href,
//       quantity,
//     };
//   }

//   function buildSmartechPayload(product, blockItem, quantity) {
//     const productUrl = BASE_URL + product.handle;
//     return {
//       prid:          product.id,
//       name:          product.title,
//       brand:         product.vendor,
//       activity_date: getFormattedDateCart(),
//       variant:       product.variant,
//       prqt:          quantity,
//       price:         product.price,
//       currency:      'INR',
//       image:         product.image,
//       produrl:       productUrl,
//       'refrer url':  productUrl,
//       producttype:   product.product_type,
//       pagetype:      window.location.href,
//       category:      blockItem?.item_category ?? '',
//       subcategory:   '',
//     };
//   }

//   // ─── Core tracker ───────────────────────────────────────────────────────────

//   function trackCartEvent(action, rawProductData, blockItem, quantity = 1) {
//     if (!GA4_EVENTS[action]) return;

//     const product = normalizeProduct(rawProductData);
//     const ga4Item = blockItem
//       ? buildGA4Item(blockItem, quantity)
//       : buildFallbackItem(product, quantity);
//     const unitPrice = blockItem?.price ?? product.price;

//     dataLayer.push({ ecommerce: null }); // clear previous ecommerce object
//     dataLayer.push({
//       event:    GA4_EVENTS[action],
//       revamp:   'yes',
//       user_id:  getUserId(),
//       ecommerce: {
//         currency: 'INR',
//         value:    +(unitPrice * quantity).toFixed(2),
//         items:    [ga4Item],
//       },
//     });

//     smartech('dispatch', SMARTECH_EVENTS[action], buildSmartechPayload(product, blockItem, quantity));
//   }

//   // ─── Cart diff ──────────────────────────────────────────────────────────────
//   function isGiftItem(rawItem) {
// console.log('rawItem', rawItem);
//     const title = rawItem?.product_title ?? rawItem?.title ?? '';
//     return title.includes('🎁');
//   }
//   async function diffAndTrackCart(newItems) {
//     const fingerprint = cartFingerprint(newItems);

//     if (fingerprint === lastCartFingerprint) return;

//     // variant:added already fired for this add — just sync state
//     if (variantAddedInProgress) {
//       previousCartMap     = buildCartMap(newItems);
//       lastCartFingerprint = fingerprint;
//       return;
//     }

//     lastCartFingerprint = fingerprint;
//     const newCartMap    = buildCartMap(newItems);

//     if (previousCartMap === null) { previousCartMap = newCartMap; return; }

//     // Items added or qty increased
//     for (const item of newItems) {
//       const prevQty = previousCartMap[item.variant_id]?.quantity ?? 0;
//       const delta   = item.quantity - prevQty;
//       if (delta === 0) continue;
//       const blockItem = await resolveBlockItem(item);
//       if (delta > 0) {
//         trackCartEvent('add',    item, blockItem, delta);
//       } else {
//         trackCartEvent('remove', item, blockItem, Math.abs(delta));
//       }
//     }

//     // Variant fully removed
//     for (const variantId of Object.keys(previousCartMap)) {
//       if (!newCartMap[variantId]) {
//         const removed   = previousCartMap[variantId];
//         const blockItem = await resolveBlockItem(removed);
//         trackCartEvent('remove', removed, blockItem, removed.quantity);
//       }
//     }

//     previousCartMap = newCartMap;
//   }

//   // ─── Init ─────────────────────────────────────────────────────────────────

//   function initCart() {
//     fetch('/cart.js')
//       .then((r) => r.json())
//       .then((cart) => {
//         const items         = cart.items ?? [];
//         previousCartMap     = buildCartMap(items);
//         lastCartFingerprint = cartFingerprint(items);
//       })
//       .catch(() => {
//         previousCartMap     = {};
//         lastCartFingerprint = '';
//       });
//   }

//   // ─── Event listeners ──────────────────────────────────────────────────────

//   // document.addEventListener('variant:added', async function (event) {
//   //   variantAddedInProgress = true;
//   //   try {
//   //     const variant   = event.detail.variant;
//   //     const blockItem = await resolveBlockItem(variant);
//   //     trackCartEvent('add', variant, blockItem);
//   //   } finally {
//   //     variantAddedInProgress = false;
//   //   }
//   // });

//   document.addEventListener('cart:updated', async function (event) {  
//     await diffAndTrackCart(event.detail.cart.items ?? []);
//   });

//   // ─── Public API ───────────────────────────────────────────────────────────

//   window.CartTracking = {
//     trackCartEvent,
//     diffAndTrackCart,
//     getProductItems,
//     resolveBlockItem,
//   };

//   initCart();
// })();


/**
 * cart-tracking.js
 * ─────────────────────────────────────────────────────────────────
 * GA4 + Smartech tracking for add/remove cart events.
 * Listens to: variant:added | cart:updated
 *
 * GA4 item objects are taken WHOLE from the product page's
 *   <script id="product-collection-data" type="application/json">
 * block. That block exposes an `items` array — one fully-formed
 * GA4 item per variant (item_id, item_name, index, item_brand,
 * item_category, item_category2, item_category3, item_variant,
 * price, quantity). The JS no longer constructs any of this; it
 * matches the right variant, decodes HTML entities, and attaches
 * the runtime quantity.
 *
 * No dependency on cart-shared.js — uses its own /cart.js fetch
 * so tracking is isolated and never contaminates the shared cache.
 * ─────────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  const BASE_URL          = 'https://plumgoodness.com/products/';
  const CURRENT_URL_TOKEN = '__CURRENT_URL__';

  const GA4_EVENTS = {
    add:    'add_to_cart',
    remove: 'remove_from_cart',
  };

  const SMARTECH_EVENTS = {
    add:    'add to cart custom',
    remove: 'remove from cart custom',
  };

  // ─── State ────────────────────────────────────────────────────────────────

  let previousCartMap        = null;
  let lastCartFingerprint    = '';
  let variantAddedInProgress = false;

  // ─── Utility ──────────────────────────────────────────────────────────────

  function getFormattedDateCart() {
    const d = new Date();
    return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
  }

  function getUserId() {
    return window.ShopifyAnalytics?.meta?.page?.customerId ?? 'guest';
  }

  function isGiftItem(rawItem) {
    const title = rawItem?.product_title ?? rawItem?.title ?? '';
    return title.includes('🎁');
  }

  function normalizeProduct(data) {
    return {
      id:           parseInt(data.product_id ?? data.id, 10),
      title:        data.product_title ?? data.title,
      vendor:       data.vendor,
      variant:      data.variant_title,
      price:        parseFloat(data.price / 100),
      image:        data.image,
      handle:       data.handle,
      product_type: data.product_type,
    };
  }

  function buildCartMap(items) {
    return items.reduce((map, item) => {
      map[item.variant_id] = item;
      return map;
    }, {});
  }

  function cartFingerprint(items) {
    return items.map((i) => `${i.variant_id}:${i.quantity}`).sort().join('|');
  }

  function decodeEntities(str) {
    if (typeof str !== 'string' || !str.includes('&')) return str;
    const el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  function decodeItem(it) {
    const out = {};
    for (const key in it) {
      out[key] = typeof it[key] === 'string' ? decodeEntities(it[key]) : it[key];
    }
    return out;
  }

  // ─── Product-block resolver ───────────────────────────────────────────────

  const productItemsCache = new Map();

  function getHandle(item) {
    return item.handle ?? item.url?.split('/products/')[1]?.split(/[?#]/)[0] ?? '';
  }

  function parseProductItems(root) {
    if (!root) return null;
    try {
      const json  = JSON.parse(root.textContent.trim());
      const items = Array.isArray(json.items) ? json.items : [];
      return items.map(decodeItem);
    } catch (_) {
      return null;
    }
  }

  async function getProductItems(rawItem) {
    const handle = getHandle(rawItem);
    if (!handle) return [];

    if (productItemsCache.has(handle)) return productItemsCache.get(handle);

    const productId = rawItem.product_id ?? rawItem.id;
    const inline    = parseProductItems(document.getElementById('product-collection-data'));
    if (inline && inline.length && String(inline[0].item_id) === String(productId)) {
      productItemsCache.set(handle, inline);
      return inline;
    }

    try {
      const html  = await fetch(`/products/${handle}`).then((r) => r.text());
      const doc   = new DOMParser().parseFromString(html, 'text/html');
      const items = parseProductItems(doc.getElementById('product-collection-data')) ?? [];
      productItemsCache.set(handle, items);
      return items;
    } catch (_) {
      return [];
    }
  }

  function matchBlockItem(items, rawItem) {
    if (!items.length) return null;
    const variantTitle = rawItem.variant_title ?? rawItem.variant ?? '';
    return (
      items.find((it) => it.item_variant === variantTitle) ??
      items[0]
    );
  }

  async function resolveBlockItem(rawItem) {
    const items = await getProductItems(rawItem);
    return matchBlockItem(items, rawItem);
  }

  // ─── Payload builders ─────────────────────────────────────────────────────

  function buildGA4Item(blockItem, quantity) {
    return {
      ...blockItem,
      item_list_name:
        blockItem.item_list_name === CURRENT_URL_TOKEN
          ? window.location.href
          : blockItem.item_list_name,
      quantity,
    };
  }

  function buildFallbackItem(product, quantity) {
    return {
      item_id:        product.id,
      item_name:      product.title,
      item_brand:     product.vendor,
      item_category:  '',
      item_category2: '',
      item_category3: '',
      item_variant:   product.variant,
      price:          product.price,
      coupon:         '',
      discount:       0,
      item_list_name: window.location.href,
      quantity,
    };
  }

  function buildSmartechPayload(product, blockItem, quantity) {
    const productUrl = BASE_URL + product.handle;
    return {
      prid:          product.id,
      name:          product.title,
      brand:         product.vendor,
      activity_date: getFormattedDateCart(),
      variant:       product.variant,
      prqt:          quantity,
      price:         product.price,
      currency:      'INR',
      image:         product.image,
      produrl:       productUrl,
      'refrer url':  productUrl,
      producttype:   product.product_type,
      pagetype:      window.location.href,
      category:      blockItem?.item_category ?? '',
      subcategory:   '',
    };
  }

  // ─── Core tracker ─────────────────────────────────────────────────────────

  function trackCartEvent(action, rawProductData, blockItem, quantity = 1) {
    if (!GA4_EVENTS[action]) return;

    const product   = normalizeProduct(rawProductData);
    const ga4Item   = blockItem
      ? buildGA4Item(blockItem, quantity)
      : buildFallbackItem(product, quantity);
    const unitPrice = blockItem?.price ?? product.price;

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event:    GA4_EVENTS[action],
      revamp:   'yes',
      user_id:  getUserId(),
      ecommerce: {
        currency: 'INR',
        value:    +(unitPrice * quantity).toFixed(2),
        items:    [ga4Item],
      },
    });

    smartech('dispatch', SMARTECH_EVENTS[action], buildSmartechPayload(product, blockItem, quantity));
  }

  // ─── Cart diff ────────────────────────────────────────────────────────────

  async function diffAndTrackCart(newItems) {
    const fingerprint = cartFingerprint(newItems);

    if (fingerprint === lastCartFingerprint) return;

    // variant:added already fired for this add — sync state only, no add event
    if (variantAddedInProgress) {
      previousCartMap     = buildCartMap(newItems);
      lastCartFingerprint = fingerprint;
      return;
    }

    lastCartFingerprint = fingerprint;
    const newCartMap    = buildCartMap(newItems);

    if (previousCartMap === null) { previousCartMap = newCartMap; return; }

    // Qty changed — add or remove
    for (const item of newItems) {
      if (isGiftItem(item)) continue;
      const prevQty = previousCartMap[item.variant_id]?.quantity ?? 0;
      const delta   = item.quantity - prevQty;
      if (delta === 0) continue;
      const blockItem = await resolveBlockItem(item);
      if (delta > 0) {
        trackCartEvent('add', item, blockItem, delta);
      } else {
        trackCartEvent('remove', item, blockItem, Math.abs(delta));
      }
    }

    // Variant fully removed
    for (const variantId of Object.keys(previousCartMap)) {
      if (!newCartMap[variantId]) {
        const removed = previousCartMap[variantId];
        if (isGiftItem(removed)) continue;
        const blockItem = await resolveBlockItem(removed);
        trackCartEvent('remove', removed, blockItem, removed.quantity);
      }
    }

    previousCartMap = newCartMap;
  }

  // ─── Init ─────────────────────────────────────────────────────────────────

  function initCart() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const items         = cart.items ?? [];
        previousCartMap     = buildCartMap(items);
        lastCartFingerprint = cartFingerprint(items);
      })
      .catch(() => {
        previousCartMap     = {};
        lastCartFingerprint = '';
      });
  }

  // ─── Event listeners ──────────────────────────────────────────────────────

  // add_to_cart: fired only via variant:added
  document.addEventListener('variant:added', async function (event) {
    const variant = event.detail.variant;
    if (isGiftItem(variant)) return;

    variantAddedInProgress = true;
    try {
      const blockItem = await resolveBlockItem(variant);
      trackCartEvent('add', variant, blockItem);
    } finally {
      setTimeout(() => { variantAddedInProgress = false; }, 500);
    }
  });

  // remove_from_cart: fired only via cart:updated diff
  document.addEventListener('cart:updated', async function (event) {
    await diffAndTrackCart(event.detail.cart.items ?? []);
  });

  // ─── Public API ───────────────────────────────────────────────────────────

  window.CartTracking = {
    trackCartEvent,
    diffAndTrackCart,
    getProductItems,
    resolveBlockItem,
  };

  initCart();
})();